export default {
  name: 'KDataGridFooter',
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.$emit('mounted')
  },
  destroyed() {
  },
  methods: {},
  render() {
    const style = {}

    const css = {
      'km-data-grid__footer': true,
    }

    const attrs = {}

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
    }

    return (
      <div {...data}>
        {this.$slots.default}
      </div>
    )
  },
}
